import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {Divider, Form, message, Steps} from "antd";
import {
  createSelectedSpecialityActionReset,
  fetchCreateAdmissionDocumentAction,
  fetchEducationEditOrderAction,
  fetchEducationOrderXMLAction,
  fetchGetInfoAction, postEducationOrderXMLAction,
  postEducationOrderXMLActionDone,
  resetGetInfoAction,
  resetStepsData,
  setStepsData
} from "../../../../store/pages/admission/actions";
import {selectStore} from "../../../../store/selector";
import {FirstStep} from "./Steps/FirstStep";
import {StyledContent, StyledSteps, StyledStepsButtons} from "./index.styles";
import {MyButton} from "../../../common/MyButton/MyButton";
import {SecondStep} from "./Steps/SecondStep";
import {FourthStep} from "./Steps/FourthStep";
import {FifthStep} from "./Steps/FifthStep";
import dayjs from "dayjs";
import {encodeBase64} from "../../../../utils/encodeBase64";
import {axiosConfigOld} from "../../../../utils/axios";


const dateFormatForBackend = "YYYY-MM-DD"

export const EntrantApplication = ({user_id, education_order_id}:any) => {
  const xmlForTest = '<?xml version="1.0" encoding="UTF-8"?><root><Привет>Мир!</Привет></root>';

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {t} = useTranslation("admission");

  const [firstForm] = Form.useForm();
  const [secondForm] = Form.useForm();
  const [thirdForm] = Form.useForm();
  const [fourthForm] = Form.useForm();
  const [fifthForm] = Form.useForm();

  const [currentStep, setCurrentStep] = useState(0);
  const [error, setError] = useState(false);

  const [educationOrderDataLoadingStepThree, setEducationOrderDataLoadingStepThree] = useState(false);

  const {profile: {userProfile: profileState}, admission: {checkIin: stateCheckIin, arrayOfSpecialities: fourSpecialtiesData, educationOrder: educationOrderData, getInfo, educationOrderXML, postEducationOrderXML, entrantApplications} } = useSelector(selectStore);

  const isExecutor = profileState.data && Array.isArray(profileState.data.roles) && profileState.data.roles.some((item: any) => item === "executor")

  const layout = {
    labelCol: { span: 8 },
    labelAlign: "left",
    wrapperCol: { span: 17 },
    size: "large"
  }

  // useEffect(() => {
  //   console.log("getInfo",getInfo.data)
  // }, [getInfo]);

  const onFinish = (values:any) => {
    // if (entrantApplications.data && Array.isArray(entrantApplications.data) && entrantApplications.data.length > 2) {
    //   message.error("Вы уже подали 2 возможные заявки")
    // } else

     if(profileState.data && !profileState?.data?.id){
      message.error("Token undefined, please reastart page")
    } else {
      if (values.birthday_entrant) {
        values.birthday_entrant = dayjs(values.birthday_entrant).format(dateFormatForBackend)
      }

      if (values.declarant_type !== "1") {
        values = {...values, is_entrant: false}
      } else {
        values = {...values, is_entrant: !isExecutor}
      }

      if (values.birthday_parent) {
        values.birthday_parent = dayjs(values.birthday_parent).format(dateFormatForBackend)
      }

      if (values.education_form != "1" && fourSpecialtiesData?.data?.length > 1) {
        message.error("Необходимо выбрать только одну специальность!")
        return false
      }

      dispatch(setStepsData(values))
      const doneObject = {...values, id: educationOrderData.data.id, user_id}

      dispatch(fetchEducationEditOrderAction(doneObject))

      setCurrentStep(currentStep + 1)
    }

  }

  const fourthStepFinish = (values:any) => {
    //@ts-ignore
    dispatch(fetchGetInfoAction({education_order_id: educationOrderData.data.id}))

    const arrayOfValues = Object.entries(values)

    /**
     * Берётся массив загруженных документов, переделывается в масив масивов и из него собирается объект, чтобы
     * запушить каждый загруженный документ
     */

    // @ts-ignore
    // eslint-disable-next-line array-callback-return
    arrayOfValues.map((items) => items[1] && items[1].map((secondItem: any) => {

      if(secondItem && secondItem.response && secondItem.response.data && secondItem.response.data.url){

      // @ts-ignore
        dispatch(fetchCreateAdmissionDocumentAction({
          id: educationOrderData.data.id,
          type: items[0],
          name: secondItem.response.data.name,
          url: secondItem.response.data.url
        }))
      }


        // dispatch(fetchCreateAdmissionDocumentAction({
        //   education_order_id,
        //   type: items[0]
        // }))
      })
    )

    if (isExecutor) {
      const doneObject = {id: educationOrderData.data.id, status: "0", user_id}
      // @ts-ignore
      dispatch(fetchEducationEditOrderAction(doneObject))
      message.success('Заявление создано!');

      navigate(`/entrant-admission-accept-reject/${encodeBase64(educationOrderData.data.id)}`, {replace: true})

    } else {
      dispatch(fetchEducationOrderXMLAction({education_order_id: educationOrderData?.data?.id}))

      setCurrentStep((prevState) => prevState + 1)
    }
  }


  async function signXml(xml:any, keyType = "SIGNATURE"){
    // @ts-ignore
    const ncaLayer = new NCALayerClient()

    try {
      await ncaLayer.connect();
    } catch (error) {
      // console.error(`Не удалось подключиться к NCALayer: ${error.toString()}`);
      alert('Не удалось подключиться к NCALayer');
      // handleStop();
      return Promise.reject();
    }
    let activeTokens;
    try {
      activeTokens = await ncaLayer.getActiveTokens();
    } catch (error) {
      // handleStop();
      // console.error(error.toString());
      console.log("error", error)
      return Promise.reject();
    }
    // @ts-ignore
    // const storageType = activeTokens[0] || NCALayerClient.fileStorageType();

    /**
     *  correctSign - Новое подписание, можно много-чего поставить, ссылка на доку - [https://sigex-kz.github.io/ncalayer-js-client/NCALayerClient.html#basicsSignXML](дока)
     */
    let correctSign;

    try {

      // @ts-ignore
      correctSign = await ncaLayer.basicsSignXML(window.NCALayerClient.basicsStorageAll, xml,  window.NCALayerClient.basicsXMLParams,  window.NCALayerClient.basicsSignerSignPerson)

    } catch (error:any) {
      // handleStop();
      message.error("Cancelled")
      return Promise.reject();
    }

    return correctSign;
  }

  const checkTypes = (data:any) => {
    let hasType1 = false;
    let hasType2 = false;

    for (const application of data) {
      if ((application.status == "2" || application.status == "0") && application.education_type === "1") {
        hasType1 = true;
      }
      if ((application.status == "2" || application.status == "0") && application.education_type === "2") {
        hasType2 = true;
      }
      if (hasType1 && hasType2) {
        break;
      }
    }

    if (hasType1 && hasType2) {
      return true
    } else {
      return false
    }
  }

  const fifthStepFinish = async () => {
    if (getInfo.data && getInfo?.data?.educationOrder && Array.isArray(getInfo?.data?.educationOrder?.selectedSpecialities) && getInfo?.data?.educationOrder?.selectedSpecialities?.length > 0) {
      if (checkTypes(entrantApplications.data)) {
        message.error('Уже создано 2 возможные заявки c типами типом "Подготовка квалифицированных рабочих кадров" и "Подготовка специалистов среднего звена, прикладных бакалавров"')
      } else {
        if (getInfo.data && getInfo?.data?.educationOrder && entrantApplications.data && entrantApplications.data.filter((application:any) => application.status == "0" || application.status == "2").some((application: any) => application.education_type == getInfo?.data?.educationOrder.education_type)) {
          message.error('Заявка с этим типом ("Подготовка квалифицированных рабочих кадров" или "Подготовка специалистов среднего звена, прикладных бакалавров") уже создана')
        } else {
          await signXml(educationOrderXML.data).then((res) => {
            if (res && !isExecutor) {
              //@ts-ignore
              axiosConfigOld.post(`/eds/verify-signed-xml-doc`, new URLSearchParams({signedXmlDoc: res}), {
                headers: {"Content-Type": "application/x-www-form-urlencoded"}
              }).then(({data}) => data).then(
                verifyResult => {

                  if (getInfo.data) {
                    const formData = new FormData();
                    formData.append("xml", res[0])

                    switch (getInfo?.data?.educationOrder?.declarant_type) {
                      case "1":
                        if (getInfo?.data?.educationOrder?.iin_entrant == verifyResult?.personData?.code) {
                          dispatch(postEducationOrderXMLAction({
                            education_order_id: educationOrderData?.data?.id,
                            xml: formData
                          }))
                        } else {
                          message.error("ИИН абитуриента в заявке не совпадает с ИИН внутри ЭЦП")
                        }
                        break;
                      case "2":
                      case "3":
                        if (getInfo?.data?.educationOrder?.iin_parent == verifyResult?.personData?.code) {
                          dispatch(postEducationOrderXMLAction({
                            education_order_id: educationOrderData?.data?.id,
                            xml: formData
                          }))
                        } else {
                          message.error("ИИН родителя в заявке не совпадает с ИИН внутри ЭЦП")
                        }
                        break;
                      default:
                        message.error("Verification error default");
                        break;
                    }
                  }
                }
              )
            }
          }).catch((e) => {
            console.log(e)
            message.error('Something went wrong')
          })
        }
      }


    } else {
      message.error("Application has incorrect data ")
    }


  }

  const onFinishFailed = (errorInfo:any) => {
    console.log('Failed:', errorInfo);

    message.error({
      content: t("failedErrorText"), style: {
        marginTop: '50vh'
      }
    })
  };

  useEffect(() => {
    if(!(getInfo?.data?.educationOrder?.docs && Array.isArray(getInfo?.data.educationOrder?.docs))){
      firstForm.setFieldsValue({
        declarant_type: "1",
        declarant_status: "1",
        iin_parent: "",
        parent_surname: "",
        parent_name: "",
        parent_patronymic_entrant: "",
        iin_entrant: "",
        surname_entrant: "",
        name_entrant: "",
        patronymic_entrant: "",
        declarant_address: "",
        phone_entrant: "",
        email_entrant: "",
        base_education: "",
        child_invalid: "2",
        quota: "2",
        invalid1and2: "2",
        vov: "2",
        village_soc_ek: "2",
        faces_kaz_nac_without_rk: "2",
        children_without_parent: "2",
        village_rk: "2",
        children_many: "2",
        family_half: "2",
        family_with_invalid: "2",
        hostel: "2",
        social_help: "2",
        accepted: "",
        user_accepted: "",
        country: "kz",
        region: "",
        district: "",
        school: "",
        series_certificate: "",
        number_certificate: "",
      })
      secondForm.setFieldsValue({})
      thirdForm.setFieldsValue({})
      fourthForm.setFieldsValue({})
      fifthForm.setFieldsValue({})
      dispatch(resetGetInfoAction())
      dispatch(resetStepsData())
    }
  }, [navigate]);

  useEffect(() => {

    if(postEducationOrderXML.data && currentStep == 3){
      if(postEducationOrderXML.data.saved){
        const doneObject = {id: educationOrderData.data.id, status: "0", user_id}
        message.success('Заявление создано!');
        dispatch(fetchEducationEditOrderAction(doneObject))

        const timer = setTimeout(() => {
          navigate("/entrant-user-applications", {replace: true})
        }, 2500)

        return () => clearTimeout(timer);
      } else {
        message.error("postEducationOrderXML error")
      }
    }
  }, [postEducationOrderXML, currentStep]);

  const currentForm = () => {
    const steps = {
      0: firstForm,
      1: secondForm,
      2: fourthForm,
      // 3: fourthForm,
      3: fifthForm,
    }

    // @ts-ignore
    return steps[currentStep]
  }


  const steps = isExecutor ? [
    {
      title: t("stepsMainCaptions.stepTwo"),
      content: <FirstStep formRef={firstForm} layout={layout} educationOrder={educationOrderData} error={error}
                      user_id={user_id} onFinish={onFinish} onFinishFailed={onFinishFailed} setError={setError} isExecutor={isExecutor}/>
    },
    {
      title: t("stepsMainCaptions.stepOne"),
      content: <SecondStep formRef={secondForm} layout={layout} educationOrder={educationOrderData} error={error} education_order_id={education_order_id} setError={setError} />
    },
    {
      title: t("stepsMainCaptions.stepFour"),
      content: <FourthStep formRef={fourthForm} layout={layout} educationOrder={educationOrderData} onFinish={onFinish} onFinishFailed={onFinishFailed} isExecutor={isExecutor}/>
    },
  ] : [
    {
      title: t("stepsMainCaptions.stepTwo"),
      content: <FirstStep formRef={firstForm} layout={layout} educationOrder={educationOrderData} error={error}
                      user_id={user_id} onFinish={onFinish} onFinishFailed={onFinishFailed} setError={setError} isExecutor={isExecutor}/>
    },
    {
      title: t("stepsMainCaptions.stepOne"),
      content: <SecondStep formRef={secondForm} layout={layout} educationOrder={educationOrderData} error={error}
                      education_order_id={education_order_id} setError={setError} />
    },
    // {
    //   title: "Оценки",
    //   content: <ThirdStep formRef={thirdForm} layout={layout} educationOrder={educationOrderData}
    //                       education_order_id={education_order_id} onFinish={onFinish} onFinishFailed={onFinishFailed}
    //                       setError={setError}
    //                       setEducationOrderDataLoadingStepThree={setEducationOrderDataLoadingStepThree}/>
    // },
    {
      title: t("stepsMainCaptions.stepFour"),
      content: <FourthStep formRef={fourthForm} layout={layout} educationOrder={educationOrderData} onFinish={onFinish}
                           onFinishFailed={onFinishFailed} isExecutor={isExecutor}/>
    },
    {
      title: "Подписание ЭЦП",
      content: <FifthStep educationOrder={getInfo.data}/>
    },
  ]

  const checkUniquePriority = (arr:any) => {
    const priorityMap = new Set<number>();

    for (const item of arr) {
      // Проверяем, является ли приоритет числом
      if (typeof item.priority !== 'number') {
        message.error("Тип приоритета не цифра")
        console.log("Invalid priority type");
        return false;
      }

      // Проверяем, что приоритет больше 0
      if (item.priority <= 0) {
        message.error("Приоритеты не должны быть меньше нуля!")
        console.log("Priority must be greater than zero");
        return false;
      }

      // Добавляем приоритет в набор
      priorityMap.add(item.priority);
    }

    // Проверяем, что количество уникальных приоритетов равно длине массива
    if (priorityMap.size !== arr.length) {
      message.error("Значения приоритета не должны повторяться!")
      console.log("Duplicate priorities found");
      return false;
    }

    // Проверяем, что все приоритеты от 1 до длины массива включительно
    for (let i = 1; i <= arr.length; i++) {
      if (!priorityMap.has(i)) {
        message.error(`Отпутствует приоритет ${i}`)
        console.log(`Missing priority ${i}`);
        return false;
      }
    }

    return true;

  }

  const handleSendApplication = (currentStep:any) => {
    switch (currentStep){
      case 0:
       currentForm().validateFields()
          .then((values: any) => {

            if(stateCheckIin.failed || !stateCheckIin.success) return message.error("Ошибка с ИИНом")

            if (values.quota == "1") {
              let check = false

              let arr = [
                "invalid1and2",
                "vov",
                "village_soc_ek",
                "faces_kaz_nac_without_rk",
                "children_without_parent",
                "village_rk",
                "children_many",
                "family_half",
                "family_with_invalid",
                "conscript",
              ]

              for (const attr of arr) {
                if (values[attr] === "1") {
                  check = true
                  break; // Прерываем цикл после первого совпадения
                }
              }

              if(check){
                onFinish(values)
              } else {
                message.error("Выберите необходимую квоту!")
              }
            } else {
              onFinish(values)
            }

          })
          .catch((error: any) => {
            onFinishFailed(error)
          })
        break;
      case 1:
        currentForm().validateFields()
          .then((values: any) => {
            if (values.education_form !== '1' || values.education_type !== '2' || values.pay_form !== '1') {
              if (fourSpecialtiesData.data && fourSpecialtiesData.data.length > 1) {
                message.error(t("admission:stepTwo.specialtyForm.error.manySpecialities"))
                return;
              }
            }

            onFinish({
              ...values,
              entrantCollegeId: isExecutor ? null : fourSpecialtiesData.data[0].college_id,
            });
          })
          .catch((error: any) => {
            onFinishFailed(error);
          });
        break;
      case 2:
        currentForm().validateFields()
          .then((values: any) => {
            fourthStepFinish(values)
          })
          .catch((error: any) => {
            onFinishFailed(error)
          })
        break;
      case 3:
        currentForm().validateFields()
          .then((values: any) => {
            if (educationOrderXML.data) {
              fifthStepFinish()
            } else {
              message.error("Не удалось сгенерировать XML!")
            }
          })
          .catch((error: any) => {
            onFinishFailed(error)
          })
        break;

      default:
        return onFinishFailed(error)
    }
  }

  return(
    <>
      <StyledSteps style={{boxShadow: "0 10px 20px rgba(107, 114, 128, 0.1)"}}>
        <Steps labelPlacement="vertical" current={currentStep} items={steps}/>
      </StyledSteps>
      <StyledContent>
        {steps[currentStep].content}
        <Divider style={{ borderColor: "#C4C8CB", marginTop: 24}} />
        <StyledStepsButtons justify="center" align="middle">
          {currentStep !== 0 ? <MyButton title={`${t('stepsMainCaptions.back')}`} height={40} onClick={() => setCurrentStep(prevState => prevState-1)} /> : null}
          <MyButton title={`${t('stepsMainCaptions.cancel')}`} height={40} style={{marginLeft: 16, marginRight: 16}} onClick={() => {

            console.log("firstForm.getFieldsValue", firstForm.getFieldsValue)
            firstForm.setFieldsValue({
              declarant_type: null,
              declarant_status: null,
              iin_entrant: null,
              surname_entrant: undefined,
              name_entrant: undefined,
              declarant_address: undefined,
              phone_entrant: undefined,
              email_entrant: undefined,
              base_education: null,
              child_invalid: null,
              quota: null,
              country: null,
              hostel: null,
              social_help: null,
              accepted: null,
              user_accepted : null,
            })

            setCurrentStep(0)

            dispatch(resetStepsData())
            dispatch(resetGetInfoAction())

            if (isExecutor) {
              window.location.replace(`${process.env.REACT_APP_FULLSTACK_URL}/education-order/work-by-executor`)
            } else {
              navigate("/entrant-user-applications", {replace: true})
            }

          }} />

            <MyButton title={`${t('stepsMainCaptions.continue')}`} height={40} onClick={() => handleSendApplication(currentStep)}/>


        </StyledStepsButtons>

      </StyledContent>
    </>
  )

}